import CloseIcon from '@mui/icons-material/Close';
import {
    AppBar,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    Slide,
    Toolbar,
    Typography,
    useTheme
} from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import React, { FC, forwardRef, useMemo, useState } from 'react';
import { SearchInput } from '../../../Form/InputSearch/input-search.component';
import { ListCustomersUseCase } from '../../../../Usecase/Customers/list-customers-usecase';
import { useToast } from '../../../../Hooks/ToasContext';
import { ICustomerEntity } from '../../../../Services/api/customers/customers.interface';
import { Table } from '../../../Table/table.component';
interface ISelectCustomerVariantProps {
    data: any
    onClose: () => void
    onSearch: (value: string) => void
    onSelect: (value: any) => void
    listCustomersUseCase: ListCustomersUseCase
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }

const SelectCustomerVariant : FC<ISelectCustomerVariantProps> = ({ data, onClose, onSearch, onSelect, listCustomersUseCase }) => {
    const [loading, setLoading] = useState(false)
    const [customers, setCustomers] = useState<ICustomerEntity[]>([])
    const { showToast } = useToast()

    const Transition = forwardRef(function Transition(
        props: TransitionProps & {
        children: React.ReactElement<any, any>;
        },
        ref: React.Ref<unknown>,
    ) {
        return <Slide direction="up" ref={ref} {...props} />;
    });
  
  const listCustomers = async ({ page, search }: { page :number; search?: string}) => {
        
    try {
      setLoading(true)
      
      const listResult = await listCustomersUseCase.handle({ page: 1, searchBy: search, personType: 'PJ'});

      if (listResult.isFailure) {
        showToast(String(listResult?.error?.error), 'error');
        return;
      }

     const response = listResult.getValue()

      console.log("listCustomers: ", response)

      if(response?.data?.length) {
        setCustomers(response?.data)
      } else {
        setCustomers([])
      }
      
   
     

    } catch (error) {
      console.log("error listArts function: ", error)
    } finally {
      setLoading(false);
    }
  };

const columns = useMemo(() => {
    const createColumns: any[] = [
      
      {
        field: 'name',
        flex: 1,
        headerName: 'Cliente',
      }
    ];
  
    return createColumns;
  }, []);

  

  return (
    <>
      <Dialog
        open
        // TransitionComponent={Transition}
        keepMounted
        onClose={onClose}
        aria-describedby="alert-dialog-slide-description"
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Buscar Cliente</DialogTitle>
        <DialogContent>
           <SearchInput
                sx={{ width: '100%', }}
                placeholder="Busque pelo nome do cliente..."
                onSearch={listCustomers}
            />

            

            <Table data={customers} columns={columns} totalCount={0} pagination={false} isRowSelectable={() => false} disableRowSelectionOnClick={false} onSelect={onSelect} onRowClick={onSelect} />

        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancelar</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SelectCustomerVariant;
